// packages/shared-hooks/src/lead-tasks/useLeadTasks.ts
//
// `GET /lead-tasks?leadId=<uuid>` — returns all OPEN tasks on a single
// lead that the actor can see. Full `LeadTask` projection; ordering is
// earliest-due first (nulls last) then by insertion order. Consumed by
// the lead drawer and episode page (#1804/#1810, #1863).
import { useQuery } from '@tanstack/react-query';
import { GetLeadTasksResponseSchema, type GetLeadTasksResponse } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadTasksKeys } from './keys.js';

export interface UseLeadTasksOptions {
  /** Disable while the auth bootstrap is still hydrating or leadId is unknown. */
  enabled?: boolean;
}

export function useLeadTasks(leadId: string, options: UseLeadTasksOptions = {}) {
  const client = useApiClient();
  return useQuery<GetLeadTasksResponse>({
    queryKey: leadTasksKeys.byLead(leadId),
    enabled: options.enabled ?? true,
    queryFn: ({ signal }) =>
      client.get<GetLeadTasksResponse>(
        '/lead-tasks',
        { signal, query: { leadId } },
        GetLeadTasksResponseSchema,
      ),
  });
}
